module.exports = __webpack_public_path__ + "static/img/logo.e949ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/logo.png
// module id = OXGA
// module chunks = 44